module.exports = __webpack_public_path__ + "img/shipo-icon-incoming-fleet.67d7587e.svg";